<section class="flex flex-col items-center gap-12">
  <app-section-header
    [title]="'Privacy & Data Protection'"
    [subtitle]="'Compliance'"
    [description]="
      'We are committed to maintaining the highest standards of security and data protection'
    "
    [icon]="'@tui.shield-check'"
  ></app-section-header>

  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-3">
    @for (compliance of compliances; track compliance.label) {
      <div class="flex flex-col items-center gap-4 text-center">
        @defer {
          <img
            [alt]="compliance.label"
            [src]="compliance.icon"
            class="h-16 w-16 object-contain"
          />
        } @placeholder {
          <div class="h-16 w-16 animate-pulse bg-gray-200"></div>
        }
        <h3 class="text-xl font-bold">{{ compliance.label }}</h3>
        <p class="text-balance text-base text-gray-600">
          {{ compliance.description }}
        </p>
      </div>
    }
  </div>
</section>
